module.exports = __webpack_public_path__ + "assets/img/4_120.c71f5ce7.jpg";